import React from 'react';
import PropTypes from 'prop-types';

import SvgGlobals from './SvgGlobals';
import ComparisonBarChart from './ComparisonBarChart';
import Card from '../design-system/cards/Card';
import DashboardButton from '../pages/Dashboard/DashboardButton';
import useAttributesComparison from '../hooks/attributes-comparison';

import rankingType, { additionalRankingType } from '../proptypes/ranking';
import phrasesType from '../proptypes/phrases';
import comparisonOptionsType from '../proptypes/comparison-options';
import attributesConfigType from '../proptypes/attributes-config';
import { ssColorBlack } from '../constants/style-constants';
import LockedContent from './LockedContent';

const selectComparison = (groupComparisons, phrases) => {
  const averageComparison = {
    id: 'average',
    name: phrases.averageRankingChartLayerName,
    spyRole: phrases.averageRankingChartLayerSubTitle,
  };
  if (groupComparisons?.length === 0) return averageComparison;

  return groupComparisons[0];
};

const AttributesCard = ({
  locked,
  title,
  ranking,
  additionalRanking,
  averageRanking,
  comparisonOptions: groupComparisonOptions,
  config,
  footer,
  phrases,
  onButtonClick,
}) => {
  const comparison = selectComparison(groupComparisonOptions, phrases);

  const { layers, attributes } = useAttributesComparison({
    ranking,
    additionalRanking,
    averageRanking,
    comparison,
    config,
    phrases,
    attributePath: null,
  });

  if (layers === undefined) return null;

  return (
    <Card h100>
      <Card.Header>{title}</Card.Header>
      <Card.Body px0>
        <LockedContent locked={locked}>
          <SvgGlobals />
          <ComparisonBarChart
            layers={layers}
            data={attributes}
            style={{ background: ssColorBlack }}
            phrases={phrases}
            comparison={comparison}
            rotateComparison={() => {}}
            carousel={{
              selected: 1,
              total: 1,
            }}
          />
        </LockedContent>
      </Card.Body>
      <Card.Footer>
        <DashboardButton
          onClickLocked={onButtonClick}
          locked={locked}
          href={footer.buttonLink}
          secondary
          my0
        >
          {footer.buttonText}
        </DashboardButton>
      </Card.Footer>
    </Card>
  );
};

AttributesCard.propTypes = {
  locked: PropTypes.bool,
  title: PropTypes.string.isRequired,
  ranking: rankingType.isRequired,
  additionalRanking: additionalRankingType.isRequired,
  averageRanking: rankingType.isRequired,
  config: attributesConfigType.isRequired,
  comparisonOptions: comparisonOptionsType.isRequired,
  phrases: phrasesType.isRequired,
  footer: PropTypes.exact({
    buttonLink: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
  }).isRequired,
  onButtonClick: PropTypes.func.isRequired,
};

AttributesCard.defaultProps = {
  locked: false,
};

export default AttributesCard;
